export default "__VITE_ASSET__CJ3C5pK9__"